import { render, staticRenderFns } from "./ReferralCopyLink.vue?vue&type=template&id=6abd9c16&"
import script from "./ReferralCopyLink.vue?vue&type=script&lang=js&"
export * from "./ReferralCopyLink.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCopyLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports